import 'lity';

import HelperCtrl from './inc/helper';
window.Helper = new HelperCtrl();

import './inc/common';
import './inc/drawer';
import './inc/catalog';
import './inc/gmap';

import './vendor/_swiper';
import './vendor/_pogo-slider';
